export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        description: entity.description || '',
        expirationDate: entity.expirationDate || null,
        type: entity.type || 'percentDiscount',
        value: entity.value || null,
        supportManualActivation: entity.supportManualActivation || false,
        supportCartActivation: entity.supportCartActivation || false,
        isGlobal: entity.isGlobal || false,
        menuCategoryId: entity.menuCategoryId || null,
        menuItemId: entity.menuItemId || null,
    };
};
